// src/react/AuthContext.ts
import { createContext } from "react";
var defaultValue = {
  user: null,
  isLoading: true,
  isAuthenticated: false,
  login: async () => void 0,
  logout: async () => void 0,
  getAccessToken: async () => {
    throw new Error("AuthContext not initialized");
  },
  handleCallback: async () => {
    throw new Error("AuthContext not initialized");
  }
};
var AuthContext = createContext(defaultValue);

export {
  AuthContext
};
//# sourceMappingURL=chunk-52JZDGH7.js.map